import { Link } from "react-router-dom";

export default function SubmitBand() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950" aria-label="投稿入口">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20anonymous%20hands%20sliding%20folded%20paper%20notes%20into%20a%20glowing%20mail%20slot%2C%20warm%20amber%20light%20rays%20against%20deep%20maroon%20background%2C%20editorial%20poster%20style%2C%20dramatic%20contrast%2C%20high%20detail&width=1600&height=700&seq=baoliao-cta-01&orientation=landscape"
          alt="匿名投稿信纸投入发光信箱的抽象插画"
          title="爆料专区 - 匿名投稿通道"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/60" />
      </div>

      <div className="relative mx-auto w-full max-w-3xl px-4 py-16 text-center md:px-8 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 font-label text-xs text-background-100 backdrop-blur">
          <i className="ri-lock-2-line text-accent-400" aria-hidden="true" />
          匿名投稿 · 可留联系方式供核实
        </span>
        <h2 className="mt-6 text-balance font-display text-2xl font-bold leading-tight text-background-50 md:text-4xl">
          你有独家线索？先写下来，剩下交给我们
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
          不需要文采，也不用实名。写清楚时间、地点和经过就行，编辑会帮你把细节整理成一篇完整的爆料。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/submit"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400 sm:w-auto"
          >
            <i className="ri-send-plane-line mr-2" aria-hidden="true" />
            立即投稿
          </Link>
          <Link
            to="/about"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            了解内容原则
          </Link>
        </div>
      </div>
    </section>
  );
}